import {
  START_REDIRECT,
  END_REDIRECT,
  PHONE_FIELD_CHANGE,
  TEXT_LINK,
  TEXT_LINK_FAIL,
  TEXT_LINK_SUCCESS
} from '../actions/types';

const INITIAL_STATE = {
  redirectTo: null,
  phone: '',
  text_loading: false,
  text_error: ''
}

export default (state = INITIAL_STATE, action) => {
  switch(action.type){
    case START_REDIRECT:
      return {
        ...state,
        redirectTo: action.payload
      };
    case END_REDIRECT:
      return {
        ...state,
        redirectTo: null
      };
    case PHONE_FIELD_CHANGE:
      return {
        ...state,
        phone: action.payload
      };
    case TEXT_LINK:
      return {
        ...state,
        text_loading: true,
        text_error: ''
      };
    case TEXT_LINK_FAIL:
      return {
        ...state,
        text_loading: false,
        text_error: action.payload
      };
    case TEXT_LINK_SUCCESS:
      return {
        ...state,
        text_loading: false
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/CommonReducer.js